import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

export const Wrapper = styled.nav`
  width: 100%;
  position: relative;
  margin: 0 auto;

  @media screen and (min-width: 769px) {
    margin: 0;
  }
`;

export const List = styled.ul<{ itemCount: number }>`
  --menu-gap: 10px;
  display: flex;
  justify-content: ${(props) => (props.itemCount >= 5 ? 'space-between' : 'space-around')};
  list-style: none;
  padding: 0 10px;
  gap: var(--menu-gap);

  @media screen and (min-width: 769px) {
    flex-direction: column;
    padding: 0 5px;
  }
`;

export const ListItem = styled.li<{ active?: boolean }>`
  flex-basis: min-content;
  min-width: 58px;
  max-width: 74px;
  height: 100%;
  position: relative;
  text-align: center;
  transition: transform 100ms ease-in-out;

  &:empty {
    display: none;
  }

  ${(props) =>
    props.active &&
    css`
      transform: translateY(-4px);
    `}

  @media screen and (min-width: 769px) {
    max-width: unset;
    width: auto;
    text-align: left;
    transform: none;
  }
`;

export const ListItemUnderlay = styled.div`
  display: none;
  pointer-events: none;

  @media screen and (min-width: 769px) {
    display: block;
    position: absolute;
    z-index: -1;
    inset: calc((var(--menu-gap) / 2)) 0;
    border-radius: 8px;
    background-color: var(--primary-light);
    opacity: 0;
    scale: 0.85;
    transition:
      background-color ease-in-out 200ms,
      opacity ease-out 100ms,
      scale ease-out 100ms;
  }
`;

export const ListItemLink = styled(NavLink)<{ active?: boolean; primary?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 16px 0 12px;
  color: inherit;
  text-decoration: none;
  font-size: 0.8em;
  font-weight: 700;
  color: white;
  gap: 5px;

  &:hover,
  &:focus {
    text-decoration: none;

    ${(props) =>
      props.primary &&
      css`
        @media screen and (max-width: 768px) {
          ${Icon} {
            background: var(--primary-button-hover-background);
            color: var(--primary-button-hover-text);
          }
        }
      `}
  }

  @media screen and (min-width: 769px) {
    min-height: calc(40px + var(--menu-gap));
    flex-direction: row;
    margin: calc((var(--menu-gap) / 2) * -1) 0;
    padding: calc(8px + (var(--menu-gap) / 2)) 12px;
    padding-left: calc(var(--gap) - 10px);
    border-radius: 8px;
    font-size: inherit;
    gap: 8px;

    &:hover,
    &:focus {
      ${ListItemUnderlay} {
        opacity: 1;
        scale: 1;
      }
    }

    ${(props) =>
      props.active &&
      css`
        color: var(--active-menu-item);

        ${ListItemUnderlay} {
          opacity: 1;
          scale: 1;
        }
      `}
  }
`;

export const TabIndicator = styled.div`
  position: absolute;
  bottom: 4px;
  width: 24px;
  height: 1px;
  margin: 0 !important;
  background: var(--active-menu-item);
  transform: translateX(-50%);

  @media screen and (min-width: 769px) {
    display: none;
  }
`;

export const Icon = styled.span<{ active?: boolean; primary?: boolean }>`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: inherit;
  line-height: 0;
  transition: background-color ease-in-out 200ms;

  img,
  svg {
    width: 100%;
    height: 100%;
  }

  ${(props) =>
    props.primary &&
    css`
      @media screen and (max-width: 768px) {
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: -40px;
        background: var(--primary-button-background);
        border-radius: var(--border-radius-round);
        color: var(--text);

        img,
        svg {
          width: 24px;
          height: 24px;
        }
      }
    `}
`;

export const Label = styled.span``;
